import { Grid } from "@mui/material";
import React from "react";
import { useStore } from "utils/useStore";
import { TestLLMClassifierAgreementResult } from "models/LLMs/Testing/TestLLMClassifierAgreementResult";
import { LLMClassifierBuilderStore } from "components/Classifiers/LLMClassifiers/Stores/LLMClassifierBuilderStore";
import { GoToConversation } from "../GoToConversation";
import { LLMExecutionResultInformation } from "../LLMExecutionResultInformation";
import { LLMReasoning } from "../LLMReasoning";
import { TestedConversationDetails } from "../TestedConversationDetails";
import { ViewLabeling } from "../ViewLabeling";
import { ViewTranscript } from "../ViewTranscript";

interface SuccessfulResultProps {
    result: TestLLMClassifierAgreementResult;
    number: number;
}

export function SuccessfulResult({ result, number }: SuccessfulResultProps) {
    const store = useStore(LLMClassifierBuilderStore);

    const resultFromStep =
        store.classifier.implementation.isLogicChain() && result.decisionStepId
            ? store.classifier.implementation.logicChainBuilder.getStepbyId(
                  result.decisionStepId,
              )
            : undefined;

    return (
        <React.Fragment>
            <TestedConversationDetails
                conversation={result.conversation}
                number={number}
                labels={{
                    human: result.conversation.labeled,
                    model: result.decision,
                }}
                wouldExecuteUnderConditions={result.wouldExecuteUnderConditions}
            />
            <Grid item>
                <LLMReasoning
                    reasoning={result.reasoning}
                    fromStep={resultFromStep?.name}
                />
            </Grid>
            {result.executionResult && (
                <Grid item>
                    <LLMExecutionResultInformation
                        executionResult={result.executionResult}
                    >
                        <LLMExecutionResultInformation.StepRunInformation />
                        <LLMExecutionResultInformation.ClassifierResultsToWrite />
                        <LLMExecutionResultInformation.ExtendedMetadataToWrite />
                        <LLMExecutionResultInformation.StepVariables />
                    </LLMExecutionResultInformation>
                </Grid>
            )}
            <Grid
                container
                item
                columnGap={1}
                alignSelf="flex-end"
                width="fit-content"
            >
                <Grid item>
                    <GoToConversation conversationId={result.conversation.id} />
                </Grid>
                <Grid item>
                    <ViewLabeling conversation={result.conversation} />
                </Grid>
                {result.executionResult?.transcript && (
                    <Grid item>
                        <ViewTranscript
                            transcript={result.executionResult.transcript}
                        />
                    </Grid>
                )}
            </Grid>
        </React.Fragment>
    );
}
